module.exports = __webpack_public_path__ + "img/icon-white-34.cedd91f8.svg";